// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.externalDeposit-table {
    width: 100%;
}

tbody:before {
    content: "@";
    display: block;
    line-height: 8px;
    text-indent: -99999px;
}

.first_th {
    border-radius: var(--radius-sm) 0 0 var(--radius-sm);
}

.last_th {
    border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
}

.externalDeposit_titleComponent {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.delete_filters {
    padding: 6px 12px;
    background-color: var(--bg);
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    color: var(--text-secondary);
    font-size: 13px;
    font-weight: 500;
    transition: all var(--transition-fast);
}

.delete_filters:hover {
    background-color: var(--primary-light);
    border-color: var(--primary);
    color: var(--primary);
}

.custom-select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    padding: 6px 12px;
    border-radius: var(--radius-sm);
    font-size: 14px;
    width: min-content;
    cursor: pointer;
    outline: none;
    color: var(--text-primary);
    transition: border-color var(--transition-fast);
}

.custom-select:hover {
    border-color: var(--text-muted);
}

.custom-select:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px var(--primary-light);
}

th {
    background-color: var(--bg);
    padding: 12px 12px;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.payout_modalContainer {
    position: block;
    width: 100%;
    height: 100%;
}

.externalDeposit_filter_component {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 10px;
    width: 20%;
}

.externalDeposit_filter_component input {
    width: max-content;
    border: 1px solid var(--border);
    padding: 6px 12px;
    border-radius: var(--radius-sm);
}

.modal_input_container {
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 15px;
    width: 100%;
    margin-bottom: 20px;
}

.modal_input_container input {
    max-width: 100%;
    border: 1px solid var(--border);
    padding: 10px 14px;
    border-radius: var(--radius-sm);
    width: 90%;
}

.modal-button-div .valider {
    padding: 8px 20px;
    border-radius: var(--radius-sm);
    background-color: var(--primary);
    border: none;
    color: white;
    font-weight: 600;
    transition: all var(--transition-fast);
}

.modal-button-div .valider:hover {
    background-color: var(--primary-hover);
}

.modal-button-div .valider:disabled {
    opacity: 0.5;
    pointer-events: none;
}

.modal_hr_button {
    margin: 20px 0;
    border: none;
    border-top: 1px solid var(--border-light);
}

.externalDeposit_statusSelected {
    background-color: var(--primary) !important;
    color: white !important;
    border-color: var(--primary) !important;
}

.externalDeposit_statusBox {
    padding: 6px 14px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    color: var(--text-primary);
    background-color: var(--bg-card);
    font-weight: 500;
    font-size: 13px;
    transition: all var(--transition-fast);
    cursor: pointer;
}

.externalDeposit_statusBox:hover {
    border-color: var(--primary);
    color: var(--primary);
}

.externalDeposit_statusFilters {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
}

.filter_component {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.linkedUserSelect {
    max-width: 100%;
    border: 1px solid var(--primary);
    padding: 8px 12px;
    border-radius: var(--radius-sm);
    background-color: var(--primary-light);
}

.linkedUserNotSelect {
    max-width: 100%;
    padding: 8px 12px;
    border-radius: var(--radius-sm);
    cursor: pointer;
    transition: background-color var(--transition-fast);
}

.linkedUserNotSelect:hover {
    background-color: var(--bg);
}

.linkedUserSelect p,
.linkedUserNotSelect p {
    margin: 0;
    padding: 0;
}

ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 10px;
}

.users_list_box {
    position: absolute;
    background-color: var(--bg-card);
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: 400px;
    overflow-y: auto;
    width: 100%;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 8px;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    box-shadow: var(--shadow-lg);
}

.input_sleectedUser {
    position: relative;
}

.relative {
    position: relative;
}

.delete_item_select {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    background-color: var(--primary);
    border-radius: 50%;
    color: #fff;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    font-size: 12px;
}

.external_deposits_matching_users_box {
    overflow-y: auto;
    max-height: 450px;
}

.external_deposit_creation_box {
    display: flex;
    flex-direction: row;
    justify-content: end;
}

.external_deposit_creation_button {
    background-color: var(--primary);
    padding: 8px 20px;
    border-radius: var(--radius-sm);
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    transition: all var(--transition-fast);
}

.external_deposit_creation_button:hover {
    background-color: var(--primary-hover);
}

.external_deposit_creation_amount_input {
    max-width: 30%;
    border: 1px solid var(--border);
    padding: 10px 14px;
    border-radius: var(--radius-sm);
    width: 20%;
}

.external_deposit_creation_bic_input,
.external_deposit_creation_iban_input {
    max-width: 30%;
    border: 1px solid var(--border);
    padding: 10px 14px;
    border-radius: var(--radius-sm);
    width: 70%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/finances/subpages/External_deposit/externalDeposit.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,gCAAgC;IAChC,+BAA+B;IAC/B,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,+CAA+C;AACnD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,2CAA2C;IAC3C,uBAAuB;IACvB,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,0BAA0B;IAC1B,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;AACd;;AAEA;;IAEI,cAAc;IACd,+BAA+B;IAC/B,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;AACd","sourcesContent":[".externalDeposit-table {\n    width: 100%;\n}\n\ntbody:before {\n    content: \"@\";\n    display: block;\n    line-height: 8px;\n    text-indent: -99999px;\n}\n\n.first_th {\n    border-radius: var(--radius-sm) 0 0 var(--radius-sm);\n}\n\n.last_th {\n    border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n}\n\n.externalDeposit_titleComponent {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.delete_filters {\n    padding: 6px 12px;\n    background-color: var(--bg);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n    color: var(--text-secondary);\n    font-size: 13px;\n    font-weight: 500;\n    transition: all var(--transition-fast);\n}\n\n.delete_filters:hover {\n    background-color: var(--primary-light);\n    border-color: var(--primary);\n    color: var(--primary);\n}\n\n.custom-select {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    padding: 6px 12px;\n    border-radius: var(--radius-sm);\n    font-size: 14px;\n    width: min-content;\n    cursor: pointer;\n    outline: none;\n    color: var(--text-primary);\n    transition: border-color var(--transition-fast);\n}\n\n.custom-select:hover {\n    border-color: var(--text-muted);\n}\n\n.custom-select:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px var(--primary-light);\n}\n\nth {\n    background-color: var(--bg);\n    padding: 12px 12px;\n    text-align: left;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.payout_modalContainer {\n    position: block;\n    width: 100%;\n    height: 100%;\n}\n\n.externalDeposit_filter_component {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    gap: 10px;\n    width: 20%;\n}\n\n.externalDeposit_filter_component input {\n    width: max-content;\n    border: 1px solid var(--border);\n    padding: 6px 12px;\n    border-radius: var(--radius-sm);\n}\n\n.modal_input_container {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    gap: 15px;\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.modal_input_container input {\n    max-width: 100%;\n    border: 1px solid var(--border);\n    padding: 10px 14px;\n    border-radius: var(--radius-sm);\n    width: 90%;\n}\n\n.modal-button-div .valider {\n    padding: 8px 20px;\n    border-radius: var(--radius-sm);\n    background-color: var(--primary);\n    border: none;\n    color: white;\n    font-weight: 600;\n    transition: all var(--transition-fast);\n}\n\n.modal-button-div .valider:hover {\n    background-color: var(--primary-hover);\n}\n\n.modal-button-div .valider:disabled {\n    opacity: 0.5;\n    pointer-events: none;\n}\n\n.modal_hr_button {\n    margin: 20px 0;\n    border: none;\n    border-top: 1px solid var(--border-light);\n}\n\n.externalDeposit_statusSelected {\n    background-color: var(--primary) !important;\n    color: white !important;\n    border-color: var(--primary) !important;\n}\n\n.externalDeposit_statusBox {\n    padding: 6px 14px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n    color: var(--text-primary);\n    background-color: var(--bg-card);\n    font-weight: 500;\n    font-size: 13px;\n    transition: all var(--transition-fast);\n    cursor: pointer;\n}\n\n.externalDeposit_statusBox:hover {\n    border-color: var(--primary);\n    color: var(--primary);\n}\n\n.externalDeposit_statusFilters {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: center;\n}\n\n.filter_component {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.linkedUserSelect {\n    max-width: 100%;\n    border: 1px solid var(--primary);\n    padding: 8px 12px;\n    border-radius: var(--radius-sm);\n    background-color: var(--primary-light);\n}\n\n.linkedUserNotSelect {\n    max-width: 100%;\n    padding: 8px 12px;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    transition: background-color var(--transition-fast);\n}\n\n.linkedUserNotSelect:hover {\n    background-color: var(--bg);\n}\n\n.linkedUserSelect p,\n.linkedUserNotSelect p {\n    margin: 0;\n    padding: 0;\n}\n\nul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 10px;\n}\n\n.users_list_box {\n    position: absolute;\n    background-color: var(--bg-card);\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    max-height: 400px;\n    overflow-y: auto;\n    width: 100%;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 10;\n    padding: 8px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    box-shadow: var(--shadow-lg);\n}\n\n.input_sleectedUser {\n    position: relative;\n}\n\n.relative {\n    position: relative;\n}\n\n.delete_item_select {\n    position: absolute;\n    right: 5px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    background-color: var(--primary);\n    border-radius: 50%;\n    color: #fff;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    font-size: 12px;\n}\n\n.external_deposits_matching_users_box {\n    overflow-y: auto;\n    max-height: 450px;\n}\n\n.external_deposit_creation_box {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n}\n\n.external_deposit_creation_button {\n    background-color: var(--primary);\n    padding: 8px 20px;\n    border-radius: var(--radius-sm);\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    color: #fff;\n    transition: all var(--transition-fast);\n}\n\n.external_deposit_creation_button:hover {\n    background-color: var(--primary-hover);\n}\n\n.external_deposit_creation_amount_input {\n    max-width: 30%;\n    border: 1px solid var(--border);\n    padding: 10px 14px;\n    border-radius: var(--radius-sm);\n    width: 20%;\n}\n\n.external_deposit_creation_bic_input,\n.external_deposit_creation_iban_input {\n    max-width: 30%;\n    border: 1px solid var(--border);\n    padding: 10px 14px;\n    border-radius: var(--radius-sm);\n    width: 70%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
